import DefaultValidation from '@/services/validations/DefaultValidation';

export default class EtapaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        

        if (!model.nome) {
            refs.nomeInput.focusedOut = true;
            validated = false;
        }
        
        return validated;
    }

}